import { useLanguage } from "@/i18n/LanguageContext";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function PrivacyPolicy() {
  const { t } = useLanguage();

  return (
    <div data-testid="privacy-page">
      <Navbar />
      <main className="pt-24 pb-24 min-h-screen bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            data-testid="privacy-back-link"
            className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 font-body mb-8 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Home
          </Link>

          <h1
            data-testid="privacy-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-gray-900 font-heading mb-4"
          >
            {t.privacy.title}
          </h1>

          <p className="text-sm text-gray-400 font-body mb-12 pb-8 border-b border-gray-200">
            {t.privacy.lastUpdated}
          </p>

          <div className="space-y-10">
            {t.privacy.sections.map((section, idx) => (
              <div key={section.title} data-testid={`privacy-section-${idx}`}>
                <h2 className="text-xl font-bold text-gray-900 font-heading mb-3">
                  {section.title}
                </h2>
                <p className="text-base leading-relaxed text-gray-600 font-body">
                  {section.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
